// These types must be kept in sync with the IdentityCategory enum in the backend
export const FEDERATED_ID = "FEDERATED_ID";
export const TEMP_ID = "TEMP_ID";
export const OTHER_ID = "OTHER_ID";
